import { Input } from "antd";
import { VyneInputAddonWrapper } from "./VyneInputAddonWrapper";
import type { InputProps } from "antd";
import type { InputRef } from "antd/es/input";
import type { ReactNode } from "react";
import type { RequireAtLeastOne } from "utils/types";
import type { SpaceCompactProps } from "antd/es/space/Compact";

type AddonRenderer = ReactNode | ((className?: string) => ReactNode);

type VyneInputWithAddonProps = Omit<InputProps, "addonBefore" | "addonAfter"> & {
    readonly addonBefore?: AddonRenderer;
    readonly addonAfter?: AddonRenderer;
    readonly wrapperProps?: Omit<SpaceCompactProps, "children">;
    ref?: React.RefObject<InputRef | null>;
};

type VyneInputWithAddonRequiredProps = RequireAtLeastOne<VyneInputWithAddonProps, "addonBefore" | "addonAfter">;

export const VyneInputWithAddon = ({
    ref,
    addonBefore,
    addonAfter,
    wrapperProps,
    className,
    ...inputProps
}: VyneInputWithAddonRequiredProps) => {
    const classNames = ["vyne-input-addon-input", className].filter(Boolean).join(" ");

    return (
        <VyneInputAddonWrapper addonBefore={addonBefore} addonAfter={addonAfter} wrapperProps={wrapperProps}>
            <Input ref={ref} className={classNames} {...inputProps} />
        </VyneInputAddonWrapper>
    );
};
